// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Patent Compounds Custom Styles ── */

/* ── Center table headers ── */
.p-datatable-thead > tr > th {
  text-align: center !important;
}

/* ── Halve sort icon size ── */
.p-sortable-column-icon {
  font-size: 7px !important;
}

/* ── Glass toolbar buttons ── */
.add-compound-btn {
  background: rgba(255,255,255,0.12) !important;
  border: 1px solid rgba(255,255,255,0.45) !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  padding: 6px 14px !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.2s ease !important;
}

.add-compound-btn:hover {
  background: rgba(255,255,255,0.22) !important;
  border-color: rgba(255,255,255,0.7) !important;
  box-shadow: 0 2px 12px rgba(255,255,255,0.15) !important;
}

.add-compound-btn:active {
  background: rgba(255,255,255,0.28) !important;
}

/* ── Row resize handle ── */
.row-resize-handle {
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;
  height: 6px;
  background: transparent;
  cursor: ns-resize;
  z-index: 5;
}

.row-resize-handle::after {
  content: '';
  position: absolute;
  left: 25%;
  right: 25%;
  top: 2px;
  height: 2px;
  background: transparent;
  border-radius: 2px;
  transition: background 0.15s;
}

.row-resize-handle:hover::after {
  background: #6366f1;
}

.row-resize-handle:active::after {
  background: #4f46e5;
  height: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/scene-pm/Projects/ProjectView/PatentCompounds/PatentCompounds.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC,+BAA+B;AAC/B;EACE,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,6CAA6C;EAC7C,mDAAmD;EACnD,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,wDAAwD;AAC1D;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["/* ── Patent Compounds Custom Styles ── */\n\n/* ── Center table headers ── */\n.p-datatable-thead > tr > th {\n  text-align: center !important;\n}\n\n/* ── Halve sort icon size ── */\n.p-sortable-column-icon {\n  font-size: 7px !important;\n}\n\n/* ── Glass toolbar buttons ── */\n.add-compound-btn {\n  background: rgba(255,255,255,0.12) !important;\n  border: 1px solid rgba(255,255,255,0.45) !important;\n  color: #ffffff !important;\n  border-radius: 8px !important;\n  padding: 6px 14px !important;\n  font-weight: 500 !important;\n  font-size: 13px !important;\n  backdrop-filter: blur(4px) !important;\n  box-shadow: none !important;\n  transition: all 0.2s ease !important;\n}\n\n.add-compound-btn:hover {\n  background: rgba(255,255,255,0.22) !important;\n  border-color: rgba(255,255,255,0.7) !important;\n  box-shadow: 0 2px 12px rgba(255,255,255,0.15) !important;\n}\n\n.add-compound-btn:active {\n  background: rgba(255,255,255,0.28) !important;\n}\n\n/* ── Row resize handle ── */\n.row-resize-handle {\n  position: absolute;\n  bottom: -3px;\n  left: 0;\n  right: 0;\n  height: 6px;\n  background: transparent;\n  cursor: ns-resize;\n  z-index: 5;\n}\n\n.row-resize-handle::after {\n  content: '';\n  position: absolute;\n  left: 25%;\n  right: 25%;\n  top: 2px;\n  height: 2px;\n  background: transparent;\n  border-radius: 2px;\n  transition: background 0.15s;\n}\n\n.row-resize-handle:hover::after {\n  background: #6366f1;\n}\n\n.row-resize-handle:active::after {\n  background: #4f46e5;\n  height: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
